// extracted by mini-css-extract-plugin
export var container = "Demo-module--container--edc2b";
export var mascot = "Demo-module--mascot--fb974";
export var mobileVideo = "Demo-module--mobile-video--729d9";
export var slideAndFade = "Demo-module--slide-and-fade--68ae9";
export var titleBar = "Demo-module--title-bar--cce7f";
export var titleBarButton = "Demo-module--title-bar-button--a4d83";
export var titleBarButtons = "Demo-module--title-bar-buttons--18796";
export var titleBarTitle = "Demo-module--title-bar-title--f2767";
export var video = "Demo-module--video--95d98";
export var videoWrapper = "Demo-module--video-wrapper--2a01c";